import { useEffect, useState, useCallback } from "react";

const CART_KEY = "ve_cart";

function read() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY) || "[]");
  } catch {
    return [];
  }
}
function write(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("ve-cart-change"));
}

export function useCart() {
  const [items, setItems] = useState(read());

  useEffect(() => {
    const on = () => setItems(read());
    window.addEventListener("ve-cart-change", on);
    return () => window.removeEventListener("ve-cart-change", on);
  }, []);

  const add = useCallback((item) => {
    const current = read();
    // Match on product+variant
    const key = JSON.stringify({ slug: item.product_slug, v: item.variant || null });
    const idx = current.findIndex(
      (c) => JSON.stringify({ slug: c.product_slug, v: c.variant || null }) === key
    );
    if (idx >= 0) {
      current[idx].quantity += item.quantity;
    } else {
      current.push(item);
    }
    write(current);
    // Fire pixel events (GA4 + Meta) — safe no-ops if trackers aren't loaded
    try {
      const value = (item.unit_price || 0) * (item.quantity || 1);
      if (typeof window.gtag === "function") {
        window.gtag("event", "add_to_cart", {
          currency: "ZAR",
          value,
          items: [
            {
              item_id: item.product_slug,
              item_name: item.name,
              price: item.unit_price,
              quantity: item.quantity,
            },
          ],
        });
      }
      if (typeof window.fbq === "function") {
        window.fbq("track", "AddToCart", {
          value,
          currency: "ZAR",
          content_ids: [item.product_slug],
          content_name: item.name,
          content_type: "product",
        });
      }
    } catch {
      /* swallow */
    }
  }, []);

  const remove = useCallback((idx) => {
    const current = read();
    current.splice(idx, 1);
    write(current);
  }, []);

  const updateQty = useCallback((idx, qty) => {
    const current = read();
    if (current[idx]) {
      current[idx].quantity = Math.max(1, qty);
      write(current);
    }
  }, []);

  const clear = useCallback(() => write([]), []);

  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return { items, add, remove, updateQty, clear, subtotal, count };
}

export const ZAR = (v) =>
  "R " + Number(v || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
